<template>
    <div class="toast fade show" role="alert" aria-live="assertive" data-bs-autohide="false" aria-atomic="true" data-toast-gravity="5" data-toast-duration="5" data-toast-close="close" data-toast-style="success">
        <div class="toast-header">
            <img src="https://img.themesbrand.com/judia/logo-sm.png" class="rounded me-2" alt="..." height="20">
            <span class="fw-semibold me-auto">Judia</span>
            <small>06 mins ago</small>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body">
            Hello, world! This is a toast message.
        </div>
    </div>
</template>
